var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundcloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91992 33.48H11.9199V19.48C10.9949 20.3298 10.3059 21.4047 9.91992 22.6V33.48ZM20.9199 18.57C19.9711 18.132 18.9583 17.8484 17.9199 17.73V33.48H20.9199V18.57ZM13.9199 33.48H16.9199V17.71C15.8958 17.7198 14.8809 17.9058 13.9199 18.26V33.48ZM3.91992 24.42C3.30291 24.8895 2.80178 25.4941 2.45506 26.1876C2.10834 26.881 1.92526 27.6447 1.91992 28.42C1.92689 29.1809 2.11131 29.9296 2.45851 30.6066C2.80571 31.2837 3.30612 31.8704 3.91992 32.32V24.42ZM40.9199 22.48C40.1279 22.4554 39.3429 22.6344 38.6399 23C38.6399 23 37.7999 14.52 29.3699 14.52C24.4599 14.52 22.5399 17.22 21.9299 18.41V33.48H40.2099C40.2099 33.48 46.0799 33.39 46.0799 28.03C46.0856 26.6209 45.5541 25.2626 44.5937 24.2315C43.6332 23.2004 42.3159 22.5741 40.9099 22.48H40.9199ZM7.91992 23.57C7.47561 23.5117 7.02804 23.4817 6.57992 23.48C6.35856 23.488 6.13803 23.5114 5.91992 23.55V33.32C6.34886 33.4243 6.78851 33.478 7.22992 33.48H7.91992V23.57Z",
    fill: "#FF5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.aca4ca49a2bfffa78825fb1eac0ecccf.svg";
export { ForwardRef as ReactComponent };